import cn from "clsx";

const FullScreenLoader = ({ show = false }) => {
  return (
    <div
      className={cn("w-full h-screen grid place-items-center", {
        hidden: !show,
      })}
    >
      <span className="text-3xl text-primary font-normal">
        Setting up your account{" "}
        <i className="fa-solid fa-spin fa-spinner ml-2"></i>
      </span>
    </div>
  );
};

export default FullScreenLoader;
